const ERP_DOMAIN = "https://erp.synqsmc.com";
const PUBLIC_DOMAIN = "https://synqsmc.com";

export const isErpHost = () => window.location.hostname.split(".")[0] === "erp";

// All login links point directly at the ERP domain.
export const erpLink = (path) => `${ERP_DOMAIN}${path}`;

// Link back to the public marketing site.
export const publicLink = (path = "/") => `${PUBLIC_DOMAIN}${path}`;
